
export const objectUpdate = (object) => {
    return {
        type: 'OBJECT_UPDATE',
        value: object
    }
};

export const objectListUpdate = (objectList) => {
    return {
        type: 'OBJECT_LIST_UPDATE',
        value: objectList
    }
};

export const languageSwitch = (language) => {
    return {
        type: 'LANGUAGE_SWITCH',
        value: language
    }
};

export const objectSwitch = (objectId) => {
    return {
        type: 'OBJECT_SWITCH',
        value: objectId
    }
};

export const changeMediaProgress = (value) => {
    return {
        type: 'CHANGE_PROGRESS',
        value
    }
};

export const changePlaying = (value) => {
    return {
        type: 'CHANGE_PLAYING',
        value
    }
};

export const setParameters = (value) => {
    return {
        type: 'SET_PARAMETERS',
        value
    }
};

